// Spanish. Machine-drafted — review with a native speaker before launch.
import type { TranslationDictionary } from './en';

const es: TranslationDictionary = {
	language: {
		label: 'Idioma',
		en: 'Inglés',
		es: 'Español',
		fr: 'Francés',
		ar: 'Árabe',
	},
	help: {
		helpMenu: 'Ayuda',
		requestFeature: 'Solicitar una función',
		helpDocs: 'Documentación',
		contactSupport: 'Contactar con soporte',
	},
	nav: {
		dashboard: 'Panel',
		cards: 'Tarjetas',
		videoCards: 'Tarjetas de vídeo',
		engagement: 'Interacción',
		settings: 'Ajustes',
		createNewCard: 'Crear tarjeta',
	},
	common: {
		save: 'Guardar',
		cancel: 'Cancelar',
		delete: 'Eliminar',
		edit: 'Editar',
		search: 'Buscar',
		loading: 'Cargando…',
		download: 'Descargar',
		share: 'Compartir',
		close: 'Cerrar',
		back: 'Atrás',
		next: 'Siguiente',
	},
	viewcard: {
		header: 'Hola %{name}, %{sender} te ha creado una tarjeta digital.',
		hi: 'Hola',
		youHaveACard: '¡Tienes una tarjeta!',
		tapEnvelopeToOpen: 'Toca el sobre para abrirla',
		sentYouACard: '%{sender} te ha enviado una tarjeta',
		tapToOpen: '👆 Toca para abrir',
		tapOrSwipeToFlip: '👆 Toca o desliza para pasar la tarjeta 👉',
		clickToOpen: 'Haz clic en la tarjeta para abrirla.',
		tapToFlip: 'Toca la tarjeta para darle la vuelta.',
		postcardFront: "Anverso de la postal. Pulsa para darle la vuelta.",
		postcardBack: "Reverso de la postal. Pulsa para darle la vuelta.",
		createYourOwn: 'Crea tu propia tarjeta gratis',
		scrollToReact: 'Desplázate para reaccionar y comentar ↓',
		reactToThisCard: 'Reacciona a esta tarjeta',
		comments: 'Comentarios',
		leaveComment: 'Deja un comentario',
		yourName: 'Tu nombre',
		writeMessage: 'Escribe un mensaje… (máx. 500 caracteres)',
		post: 'Publicar',
		postAnonymously: 'Publicar de forma anónima',
		shareToWhatsapp: 'Compartir en WhatsApp',
		copyLink: 'Copiar enlace',
		linkCopied: '¡Enlace copiado!',
		shareViaEmail: 'Compartir por correo',
		shareOnX: 'Compartir en X',
	},
	music: {
		play: 'Reproducir música',
		pause: 'Pausar música',
		volume: 'Volumen',
	},
	promo: {
		headline: 'Añade un mensaje en vídeo a tus tarjetas.',
		subline: 'Que te vean y te escuchen, no solo que te lean. Un solo pago, sin suscripción.',
		cta: 'Acceso de por vida',
		daysLeft: 'Quedan %{count} días',
		lastDay: 'Último día',
	},
	unsub: {
		title: 'Preferencias de correo',
		confirmHeading: '¿Cancelar la suscripción a estos correos?',
		confirmBody: 'Dejarás de recibir tarjetas y correos de este remitente. No cambia nada más.',
		confirmButton: 'Sí, cancelar mi suscripción',
		keepButton: 'No, seguir suscrito',
		processing: 'Actualizando tus preferencias…',
		successHeading: 'Has cancelado tu suscripción',
		successBody: 'Ya no recibirás estos correos.',
		successNote: '¿Cambiaste de opinión? Contacta directamente con el remitente para que vuelva a añadirte.',
		keptHeading: 'Sigues suscrito',
		keptBody: 'No se ha hecho ningún cambio. Puedes cerrar esta página.',
		errorHeading: 'Algo salió mal',
		errorBody: 'No hemos podido procesar tu solicitud. Inténtalo de nuevo en un momento.',
		errorMissing: 'Este enlace para cancelar la suscripción está incompleto. Usa el enlace de tu correo.',
		tryAgain: 'Intentar de nuevo',
	},
};

export default es;
